import { Outlet } from 'react-router-dom';

const Portal = props => {
    return (
        <div id='portal-container'>
            <Outlet />
        </div>
    )
}

export default Portal;